import { ComponentProps } from 'react';

import { FilesTable } from '@/react/docker/components/FilesTable';
import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';

import { createPersistedStore } from '@@/datatables/types';
import { useTableState } from '@@/datatables/useTableState';

import { buildUrl } from './build-url';

const tableKey = 'host-browser';

const settingsStore = createPersistedStore(tableKey, 'Name');

interface Props extends Omit<
  ComponentProps<typeof FilesTable>,
  'onSearchChange' | 'tableState' | 'title' | 'getDownloadLink'
> {
  relativePath: string;
  volumeId: string;
}

export function AgentVolumeBrowser({
  relativePath,
  dataset,
  isRoot,
  onBrowse,
  onDelete,
  onFileSelectedForUpload,
  onGoToParent,
  onRename,
  isUploadAllowed,
  volumeId,
}: Props) {
  const envId = useEnvironmentId();
  const tableState = useTableState(settingsStore, tableKey);

  return (
    <FilesTable
      tableState={tableState}
      dataset={dataset}
      title={`Volume browser - ${relativePath}`}
      isRoot={isRoot}
      onRename={onRename}
      onBrowse={onBrowse}
      getDownloadLink={(fileName) =>
        `/api${buildUrl({
          envId,
          action: 'get',
        })}?path=${fileName}&volumeID=${volumeId}`
      }
      onDelete={onDelete}
      isUploadAllowed={isUploadAllowed}
      onFileSelectedForUpload={onFileSelectedForUpload}
      onGoToParent={onGoToParent}
    />
  );
}
